export default __webpack_public_path__ + "static/media/Classwin-aspect-ratio-sixteen-to-nine-focus.7ffafc6c.svg";